import api, { IPaginationResponse } from 'config/axios';
import AppService from 'common/app-service';
import {
  CreateTakerPayload,
  CreateTakerRootSerasaScore,
  EditTakerPayload,
  ITakerRoot,
  ITakerBranch,
  ITakerRootSerasaScore,
  ITakersFilters,
} from 'common/taker.interface';

export default class TakersService extends AppService {
  constructor() {
    super('takers', api);
  }

  async all(page: number, limit = 10, filters?: Partial<ITakersFilters>): Promise<IPaginationResponse<ITakerRoot>> {
    const response = await this.api.get(this.root(), { params: { page, limit, ...(filters || {}) } });

    return response.data;
  }

  async notPaginatedAll() {
    const { total } = await this.all(1);
    const response = await this.all(1, total);

    return response.items;
  }

  async createRootTaker(taker: CreateTakerPayload) {
    const response = await this.api.post(this.root(), taker);

    return response.data;
  }

  async editRootTaker(takerId: number, taker: EditTakerPayload) {
    const response = await this.api.put(`${this.root()}/${takerId}`, taker);

    return response.data;
  }

  async getTakerRoot(id: number) {
    const response = await this.api.get(`${this.root()}/${id}`);

    return response.data;
  }

  async getTakerBranches(id: number, page = 1) {
    const response = await this.api.get(`${this.root()}/${id}/branches`, { params: { page } });

    return response.data;
  }

  /**
   * Works only for Customers user roles
   */
  async getTakerBranchesFromAvailableCTes(): Promise<IPaginationResponse<ITakerBranch>> {
    const response = await this.api.get(`${this.root()}/branches`);

    return response.data;
  }

  async getTakerRootsFromAvailableCTes(): Promise<IPaginationResponse<ITakerRoot>> {
    const response = await this.api.get(`${this.root()}/roots`);

    return response.data;
  }

  async getTakerRootScore(id: number, page = 1): Promise<IPaginationResponse<ITakerRootSerasaScore>> {
    const response = await this.api.get(`${this.root()}/${id}/serasa-scores`, { params: { page } });

    return response.data;
  }

  async createTakerRootScore(takerId: number, data: CreateTakerRootSerasaScore) {
    const response = await this.api.post(`${this.root()}/${takerId}/serasa-scores`, {
      ...data,
      queriedIn: data.queriedIn.toISODate(),
    });

    return response.data;
  }
}
